class InteractiveQuizElement extends HTMLDivElement {
  constructor() {
    super();

    this.severityContentWrapper = this.querySelector('.severity-content-wrapper');
    this.severityItems = this.severityContentWrapper.querySelectorAll('.severity-content__item');
    this.severityActiveItem = this.querySelector('.severity-content__item.active');
    this.slider = this.severityContentWrapper.querySelector('.severity-slider');
    this.concernSelect = this.querySelector('#concern-select');
    this.loader = this.severityActiveItem.querySelector('.loader');
    this.quizModalButton = this.querySelector('.quiz-modal-button');
    this.severityInfoBox = this.severityContentWrapper.querySelector('.severity-info__box');
    this.selects = this.querySelectorAll('.quiz-input .select');

    if (
      !this.severityActiveItem ||
      !this.slider ||
      !this.severityContentWrapper ||
      !this.concernSelect ||
      !this.quizModalButton
    )
      return;

    this.formState = {
      severity: this.severityInfoBox.textContent,
      cost: this.dataset.costExpressTopArch,
      treatment: this.dataset.treatmentExpress,
    };

    this.selects.forEach((select) => {
      select.addEventListener('change', this.handleChange.bind(this));
      const newFormState = {
        ...this.formState,
        [select.name]: select.value,
      };

      this.formState = newFormState;
    });

    this.init();
    this.slider.addEventListener('input', this.init.bind(this));
    this.concernSelect.addEventListener('change', this.updateVideo.bind(this));
    this.quizModalButton.addEventListener('click', this.handleQuizModalButton.bind(this));
  }

  init() {
		const video = this.severityActiveItem.querySelector('.severity-media__video');
		if (!video) return;

		const value = parseFloat(this.slider.value);
		if (isNaN(value)) return;

		const duration = video.duration;
		if (!duration || !isFinite(duration)) return;

		// Calculate target time
		this.targetSeekTime = duration - value * duration;

		// Prevent crazy seeking speeds → do at most 1 per animation frame
		if (!this.isSeeking) {
			this.isSeeking = true;

			requestAnimationFrame(() => {
				if (isFinite(this.targetSeekTime)) {
					video.currentTime = this.targetSeekTime;
				}
				this.isSeeking = false;
			});
		}

		this.updateSeverityIndicator(value);
	}

  updateVideo(e) {
    this.showLoader();
    const concern = e.target.value;
    const concernItem = this.querySelector(`#severity-${concern}`);
    const video = concernItem.querySelector('.severity-media__video');
    this.severityActiveItem = concernItem;

    this.severityItems.forEach((item) => {
      item.classList.remove('active');
    });
    concernItem.classList.add('active');

    const value = parseFloat(this.slider.value);
    video.load();

    video.addEventListener(
      'loadedmetadata',
      () => {
        this.hideLoader();
        if (video.duration && isFinite(video.duration)) {
          const time = video.duration - value * video.duration;
          if (isFinite(time)) {
            video.currentTime = time;
          }
        }
      },
      { once: true },
    );

    video.addEventListener('error', () => {
      console.error('Video loading error');
      this.hideLoader();
    });
  }

  updateSeverityIndicator(value) {
		const severityInfos = this.dataset.severityInfo
			.split(',')
			.map((info) => info.trim());

		const { archType } = this.formState;
		const total = severityInfos.length;

		// Convert slider value (0 → min, 1 → max) into a dynamic severity
		let index = Math.floor(value * total);

		// Clamp index so it doesn't overflow
		if (index >= total) index = total - 1;

		const severity = severityInfos[index];

		this.formState = {
			...this.formState,
			severity,
			cost:
				archType === "top-arch"
					? this.dataset[`cost${severity}TopArch`]
					: this.dataset[`cost${severity}DualArches`],
			treatment: this.dataset[`treatment${severity}`],
		};

		this.severityInfoBox.textContent = severity;
	}

  updateQuizResults() {
    const { severity, cost, treatment } = this.formState;

    const severityResult = document.querySelector('[data-result-severity]');
    const costResult = document.querySelector('[data-result-cost]');
    const treatmentResult = document.querySelector('[data-result-treatment]');

    if (!severityResult || !costResult || !treatmentResult) return;

    severityResult.textContent = severity;
    costResult.textContent = cost;
    treatmentResult.textContent = treatment;
  }

  handleChange(e) {
    const { value } = e.target;

    const newFormState = {
      ...this.formState,
      [e.target.name]: value,
    };

    const { archType, severity } = newFormState;

    this.formState = {
      ...newFormState,
      cost:
        archType === 'top-arch' ? this.dataset[`cost${severity}TopArch`] : this.dataset[`cost${severity}DualArches`],
    };

    this.updateQuizResults();
  }

  handleQuizModalButton() {
    this.updateQuizResults();
  }

  showLoader() {
    this.loader.style.display = 'block';
  }

  hideLoader() {
    this.loader.style.display = 'none';
  }
}

customElements.define('interactive-quiz', InteractiveQuizElement, { extends: 'div' });
